import {isTruthy} from '@wandb/weave/common/util/types';
import React, {useState} from 'react';

import {BaseSearchHistoryItem, OptionTypeBase} from '../../PanelBank/types';
import {
  MAX_SEARCH_STRING_HISTORY,
  useRunComparerContext,
} from '../RunComparerContextProvider';
import {SearchHistory} from './SearchHistory';

export const SearchConfigs = () => {
  const {
    addValueToSearchStringHistory,
    localSearchStringHistory,
    localSearchString,
    debouncedAddValueToSearchStringHistory,
  } = useRunComparerContext();
  // this state is needed to control the input field - it is updated with every keystroke
  const [inputSearchString, setInputSearchString] = useState<
    string | undefined
  >(localSearchString);
  return (
    <SearchHistory<BaseSearchHistoryItem, OptionTypeBase>
      dataTest="run-comparer-search-configs"
      searchHistory={
        localSearchStringHistory
          ?.filter(isTruthy) // filter out empty search strings because it's weird if they show up in the dropdown
          ?.map(s => ({
            query: s,
          })) ?? []
      }
      onOptionChange={({value}: OptionTypeBase) => {
        if (value !== undefined) {
          // "enter" key calls this with value undefined
          setInputSearchString(value);
          addValueToSearchStringHistory(value); // don't debounce when selecting an option directly from the dropdown
        }
      }}
      onClear={() => {
        setInputSearchString(undefined);
        addValueToSearchStringHistory(undefined);
      }}
      placeholderText="Search configs"
      maxItems={MAX_SEARCH_STRING_HISTORY}
      inputValue={inputSearchString ?? ''}
      setInputValue={(value: string) => {
        if (value !== undefined) {
          // "enter" key calls this with value undefined
          setInputSearchString(value);
          debouncedAddValueToSearchStringHistory(value); // debounce adding the value to history to avoid re-constructing the tree on every keystroke
        }
      }}
      selectedOption={
        localSearchString
          ? {value: localSearchString, label: localSearchString}
          : null
      }
    />
  );
};
